export const makeNumber = (value: number | string | null | undefined) => {
  const num = parseFloat((value ?? '0').toString().replace(/\s+/g, ''));

  if (Number.isNaN(num)) return 0;

  return num;
};
